<template>
  <div>
    <h2 class="my-5 text-center"><strong>POLÍTICA DE PRIVACIDADE</strong></h2>

    <p>
      Ao utilizar o site do Comenta.Aí, “comenta.ai” (a “<u>Plataforma</u>”), o
      Usuário consenti, de forma livre e expressa, que seus dados pessoais (os
      “Dados Pessoais”) e informações sejam coletados, armazenados, tratados e
      compartilhados, conforme as regras dispostas nesta Política de Privacidade
      (a “<u>Política de Privacidade</u>”).
    </p>

    <h2 class="my-5 text-center"><strong>I – DEFINIÇÕES</strong></h2>

    <p>
      <strong>Usuário:</strong> todas as pessoas físicas, maiores de 18
      (dezoito) anos ou emancipadas e totalmente capazes de praticar os atos da
      vida civil ou os absolutamente ou relativamente incapazes devidamente
      representados ou assistidos - e jurídicas cadastradas na Plataforma.
    </p>

    <p>
      <strong>Plataforma:</strong> sistema oferecido pelo Comenta.Aí e de
      propriedade, operação e responsabilidade do Comenta.Aí, utilizado como o
      meio para que os Usuários realizem a avaliação (a “<u
        >Pesquisa de Satisfação</u
      >”) sobre os serviços ofertados e atendimento pelo estabelecimento (o
      “<u>Estabelecimento</u>”).
    </p>

    <p>
      <strong>Dados Pessoais: </strong> quaisquer informações fornecidas e/ou
      coletadas pelo Comenta.Aí, do Usuário que consentiu em disponibilizá-los
      ao fazer o compartilhamento dos seus dados pessoais (o “<u
        >Compartilhamento de Dados Pessoais</u
      >”) na Plataforma, por qualquer meio, ainda que públicos: (i) que
      identifiquem um indivíduo diretamente ou que, quando combinada com demais
      informações coletadas pelo Comenta.Aí, identificarem um indivíduo; ou (ii)
      através das quais a identificação ou informações de contato de uma pessoa
      física possam ser derivadas. Os Dados Pessoais podem estar em qualquer
      mídia ou formato, inclusive registros eletrônicos ou computadorizados, bem
      como em arquivos baseados em papel. Os Dados Pessoais, no entanto, não
      incluem telefone comercial, número de celular comercial, endereço
      comercial e e-mail comercial.
    </p>

    <p>
      <strong>Finalidade:</strong> o objetivo, o propósito que o Comenta.Aí
      deseja alcançar a partir de cada ato de tratamento das informações
      pessoais.
    </p>

    <p>
      <strong>Necessidade:</strong> justificativa pela qual é estritamente
      necessário coletar Dados Pessoais, para atingir a finalidade, evitando-se
      a coleta excessiva.
    </p>

    <p>
      <strong>Consentimento: </strong>autorização expressa e inequívoca dada
      pelo Usuário titular do Dado Pessoal para que o Comenta. Aí trate seus
      dados pessoais para uma finalidade previamente descrita, na qual a base
      legal necessária para o ato demande a autorização expressa do titular.
      Esta Política de Privacidade se aplica, em geral, a todos os Usuários que
      realizem a Pesquisa de Satisfação sobre os serviços, produtos e
      atendimento oferecido pelo Estabelecimento, negativo ou positivo, com a
      disponibilização de seus Dados Pessoais, mediante realização do
      <u>Compartilhamento de Dados Pessoais </u>na Plataforma, e resume como o
      Comenta.Aí poderá coletar, produzir, receptar, classificar, utilizar,
      acessar, reproduzir, transmitir, distribuir, processar, arquivar,
      armazenar, eliminar, avaliar ou controlar a informação, bem como
      modificar, comunicar, transferir, difundir ou extrair os dados coletados,
      incluindo as informações de identificação pessoal, de acordo com as bases
      legais aplicáveis e todas as leis de privacidade e proteção de dados em
      vigor.
    </p>

    <p>
      <strong>Ao acessar e/ou utilizar a Plataforma do </strong
      >Comenta.Aí<strong
        >, o Usuário declara ter no mínimo 18 (dezoito) anos e ter capacidade
        plena e expressa para a aceitação dos termos e condições desta Política
        de Privacidade e do Termo de Uso do Usuário para todos os fins de
        direito.</strong
      >
    </p>

    <p>
      Caso o Usuário não se enquadre na descrição acima e/ou não concorde, ainda
      que em parte, com os termos e condições contidos nesta Política de
      Privacidade, não deverá acessar e/ou utilizar os serviços oferecidos pelo
      Comenta.Aí.
    </p>

    <h2 class="my-5 text-center"><strong>II - DISPOSIÇÕES GERAIS:</strong></h2>

    <p>
      <strong>2.1.</strong> O Usuário declara-se o responsável pelas informações
      que disponibilizar através da realização de
      <u>Compartilhamento de Dados Pessoais</u> na Plataforma do Comenta.Aí e
      que será compartilhada com o Estabelecimento.
    </p>

    <p>
      <strong>2.1.1.</strong> O Usuário está ciente de que fornece informação de
      forma consciente e voluntária por meio de
      <u>Compartilhamento de Dados Pessoais</u> na Plataforma.
    </p>

    <p>
      <strong>2.1.2.</strong> Quando o Usuário realiza o
      <u>Compartilhamento de Dados Pessoais </u>e/ou preenche formulários
      oferecidos pelo Comenta.Aí em sua Plataforma, determinados Dados Pessoais
      solicitados serão mantidos em sigilo e serão utilizados apenas para o
      propósito que motivou o <u>Compartilhamento de Dados Pessoais</u
      ><em>.</em>
    </p>

    <p>
      <strong>2.2.</strong> É autorizado ao Comenta.Aí o armazenamento e a
      coleta de dados cadastrais do Usuário (como ), conforme os Termos de Uso.
    </p>

    <p>
      <strong>2.2.1. </strong>O Comenta.Aí reterá os Dados Pessoais do Usuário e
      os manterá armazenados até eventual requerimento de exclusão pelo
      Estabelecimento, ou tempo necessário, respeitando as premissas legais.
    </p>

    <p>
      <strong>2.2.2.</strong> O Comenta.Aí poderá vir a manter os Dados Pessoais
      do Usuário mesmo após receber seu pedido de exclusão caso seja necessário
      para cumprimento de obrigações legais, resolver disputas, manter a
      segurança, evitar fraudes e abuso e garantir o cumprimento de contratos.
    </p>

    <p>
      <strong>2.3. </strong> Havendo consentimento por parte do Usuário, quando
      este for realizar a <u>Pesquisa de Satisfação</u> do Estabelecimento, é
      autorizado ao Comenta.Aí o Compartilhamento dos Dados Pessoais do Usuário,
      como nome, número de telefone, entre outros, com o Estabelecimento, uma
      vez que esta ação é imprescindível para a formação, realização e execução
      da finalidade da Plataforma.
    </p>

    <p>
      <strong>2.3.1.</strong> O Comenta.Aí não é responsável pela atividade do
      Estabelecimento e não garante que o Estabelecimento possua padrão de
      proteção de Dados Pessoais e segurança da informação compatíveis com esta
      Política de Privacidade, a fim de que os Dados Pessoais dos Usuários
      estejam sempre protegidos nestes termos.
    </p>

    <p>
      <strong>2.4</strong>. É reservado o direito ao Comenta.Aí de compartilhar
      informações dos Usuários a autoridades quando houver motivos suficientes
      para considerar que a atividade de um Usuário é suspeita, ilegal ou
      prejudicial ao Comenta.Aí ou a terceiros.
    </p>

    <p>
      <strong>2.5.</strong> O Comenta.Aí apenas trata Dados Pessoais em
      situações em que está autorizado legalmente ou mediante expresso e
      inequívoco consentimento do Usuário ao realizar o
      <u>Compartilhamento de dados Pessoais</u> na Plataforma.
    </p>

    <p>
      <strong>2.6.</strong> O Comenta.Aí trata os Dados Pessoais dos Usuários
      com alto grau de segurança, utilizando-se de práticas em uso na indústria
      para a proteção de Dados Pessoais, tais como técnicas de criptografia,
      monitoração e testes de segurança periódicos. Todavia, não é possível
      garantir completamente a não ocorrência de interceptações e violações dos
      sistemas e bases de dados da Plataforma, visto que a internet possui sua
      estrutura de segurança em permanente aperfeiçoamento.
    </p>

    <p>
      <strong>2.7.</strong>O Comenta.Aí oferece aos Usuários diversas opções do
      que fazer com seus Dados Pessoais coletados, tratados e armazenados, como
      direito de acessar e controlar seus dados pessoais, incluindo sua exclusão
      e/ou correção. O Usuário pode, a qualquer momento:
    </p>

    <p class="ml-15">
      (i) Colocar objeções, limites ou restrições ao uso de Dados Pessoais: o
      Usuário pode solicitar a interrupção do uso de todos ou alguns de seus
      Dados Pessoais (por exemplo, se não tivermos o direito de continuar a
      usá-los), ou limitar a nossa utilização de tais dados (por exemplo, se
      seus Dados Pessoais estiverem incorretos ou armazenados ilegalmente),
      destacando-se que o Comenta.Aí poderá tratar os Dados Pessoais de acordo
      com as bases legais; e
    </p>

    <p class="ml-15">
      (ii) O Usuário tem direito de acessar ou levar seus Dados Pessoais: o
      Usuário pode solicitar uma cópia dos seus Dados Pessoais e dos dados que o
      Usuário forneceu em um formato legível sob a forma impressa ou por meio
      eletrônico.
    </p>

    <p>
      <strong>2.8.</strong> O Comenta.Aí poderá atualizar essa Política de
      Privacidade periodicamente, sendo que a versão em vigor será sempre a mais
      recente, que estará disponível na Plataforma.
    </p>

    <p>
      <strong>2.9. </strong>O presente instrumento é regido pelas Leis
      Brasileiras, ficando eleito o foro da cidade de Porto Alegre/RS, como
      único competente para dirimir questões decorrentes da presente Política de
      Privacidade, com renúncia expressa a qualquer outro foro, por mais
      privilegiado que seja.
    </p>

    <p>
      <strong>2.10.</strong> A Plataforma utiliza cache local de informações
      para um melhor desempenho, bem como sistemas de <em>tracking </em>de
      navegação.
    </p>

    <h2 class="my-5 text-center">
      <strong>III - Como usamos as informações pessoais que coletamos?</strong>
    </h2>

    <p>
      <strong>3.1.</strong> Nossa finalidade principal ao coletar informações
      pessoais é fornecer ao Usuário uma experiência segura, tranquila,
      eficiente e personalizada. Para isso, usamos suas informações pessoais
      para:
    </p>

    <ul class="ml-15 mb-5">
      <li>
        compartilhar os Dados Pessoais do Usuário com Estabelecimentos, visando
        melhorar o oferecimento de serviços, produtos e atendimento pelo
        Estabelecimento ao Usuário;
      </li>
      <li>
        proporcionar maior transparência na relação entre Usuário e
        Estabelecimento; e
      </li>

      <li>
        impedir atividades potencialmente proibidas ou ilegais e garantir a
        aplicação do nosso Termo de Uso do Usuário.
      </li>
    </ul>

    <p>
      <strong>3.2.</strong> Os Dados Pessoais dos Usuários da Plataforma poderão
      ser coletados e tratados sempre em observância à Lei, conforme a cláusula
      VI do Termo de Uso do Usuário, bem como esta Política de Privacidade.
    </p>

    <h2 class="my-5 text-center">
      <strong
        >IV - Como e quando compartilhamos informações pessoais com outras
        partes?</strong
      >
    </h2>

    <p>
      <strong>4.1.</strong> Podemos compartilhar seus Dados Pessoais nas
      seguintes situações e nos limites exigidos e autorizados pela Lei: (i) Aos
      Estabelecimentos, com seu consentimento ou orientação para tanto, após
      realização de <u>Compartilhamento de Dados Pessoais</u> na Plataforma; e
      (ii) Às autoridades policiais, oficiais do governo ou outros terceiros
      quando: a) formos obrigados a isso por intimação, decisão judicial ou
      procedimento legal semelhante; b) estivermos cooperando com uma
      investigação policial em andamento; e c) para reportar atividade ilegal
      suspeita ou investigar violações do nosso Termo de Uso do Usuário.
    </p>

    <p>
      <strong>4.2.</strong> A garantia da confidencialidade dos Dados Pessoais
      dos Usuários da Plataforma é importante para o Comenta.Aí: a presente
      Política de Privacidade está de acordo com a Constituição Federal
      Brasileira, a Lei Geral de Proteção de Dados, o Marco Civil da Internet e
      as demais normas regulamentadoras.
    </p>

    <p>
      <strong>4.2.1.</strong> As informações que coletamos são: a) Nome; b) CPF;
      c) Data de Nascimento; d) Endereço de e-mail; e e) Telefone para contato.
    </p>

    <p>
      <strong>4.3.</strong> O uso da Plataforma pressupõe a aceitação desta
      Política de Privacidade que poderá vir a ser alterada pelo Comenta.Aí,
      sempre constando a versão mais atualizada no site comenta.ai.
    </p>
  </div>
</template>

<script>
export default {};
</script>

<style></style>
